import { HYDRATE } from 'next-redux-wrapper';
import { RootState } from './rootReducer.types';

export enum SearchType {
    ForSale = 'for-sale',
    ToRent = 'to-rent',
    NewHomes = 'new-homes'
}

export type SearchPageType = SearchType | 'for-sale' | 'to-rent' | 'new-homes';

export type SearchSource = 'refine' | 'facets' | '' | 'home' | 'new-homes-dev';

export enum ACTION_TYPES_SEARCH_RESULT {
    UPDATE_TOTAL_RESULTS = 'searchResults/UPDATE_TOTAL_RESULTS',
    UPDATE_PAGE_NUMBER = 'searchResults/UPDATE_PAGE_NUMBER',
    UPDATE_TOTAL_RESULTS_WAS_LIMITED = 'searchResults/UPDATE_TOTAL_RESULTS_WAS_LIMITED',
    UPDATE_POLYENC = 'searchResults/UPDATE_POLYENC'
}

// Types
export interface UpdateTotalResultsAction {
    type: typeof ACTION_TYPES_SEARCH_RESULT.UPDATE_TOTAL_RESULTS;
    totalResults: number;
}

export interface UpdatePageNumberAction {
    type: typeof ACTION_TYPES_SEARCH_RESULT.UPDATE_PAGE_NUMBER;
    pageNumber: number;
}

export interface UpdateTotalResultsWasLimitedAction {
    type: typeof ACTION_TYPES_SEARCH_RESULT.UPDATE_TOTAL_RESULTS_WAS_LIMITED;
    totalResultsWasLimited: boolean;
}

export interface UpdatePolyencAction {
    type: typeof ACTION_TYPES_SEARCH_RESULT.UPDATE_POLYENC;
    polyenc: string | null;
}

export interface HydrateFiltersAction {
    type: typeof HYDRATE;
    payload: RootState;
}

export type SearchResultsActionTypes =
    | UpdateTotalResultsAction
    | UpdatePageNumberAction
    | UpdateTotalResultsWasLimitedAction
    | UpdatePolyencAction
    | HydrateFiltersAction;

export type SearchResultsState = {
    totalResults: number;
    pageNumber: number;
    totalResultsWasLimited: boolean;
    polyenc: string | null;
};
